export default {
  langName: "English",
  common: {
    company: "An Eagle Inc company",
    privacy: "Privacy",
    terms: "Terms of use",
    support: "Support",
  },
  nav: {
    group: "Eagle Eyes Group",
    realEstate: "Real Estate",
    itManagement: "IT Management",
    digitalServices: "Digital Services",
    backToGroup: "Eagle Eyes Group",
    property: "Property",
    investment: "Investment",
  },
  form: {
    name: "Full name",
    email: "Email address",
    sending: "Sending…",
    sent: "Thank you — your details are in. We'll be in touch shortly.",
    error: "Something went wrong. Please try again or email us directly.",
  },
  gateway: {
    hero1: "EAGLE",
    hero2: "EYES",
    hero3: "GROUP",
    chapters: [
      { num: "01", name: "Real Estate", sub: "Property · Investment — Tirana", desc: "Rental homes looked after with care, and a verifiable, disciplined approach to residential real estate investment.", cta: "Enter Real Estate" },
      { num: "02", name: "IT Management", sub: "Consultancy & managed services", desc: "Senior IT consultancy across cloud, identity, security and DevOps — scoped precisely, delivered personally, managed for the long term.", cta: "Enter IT Management" },
      { num: "03", name: "Digital Services", sub: "Products we build & run", desc: "A growing portfolio of live web and mobile products in social commerce, marketing and booking — designed, launched and operated in-house.", cta: "Enter Digital Services" },
    ],
    footerBrand: "Eagle Eyes Group",
  },
  re: {
    forClients: "For clients",
    propertyH: "Property",
    propertyP: "Rental homes in central Tirana, found and looked after with care. For people who want a place to live, not a transaction.",
    propertyCta: "Enter Eagle Eyes Property",
    forInvestors: "For investors",
    investmentH: "Investment",
    investmentP: "A verifiable, disciplined approach to Tirana residential real estate. For those who want to see exactly what they're backing.",
    investmentCta: "Enter Eagle Eyes Investment",
  },
  property: {
    kicker: "Eagle Eyes Property",
    h1: "A home in Tirana, watched over from the start.",
    intro: "We find, prepare, and manage rental apartments in central Tirana — for tenants who want a home that's handled properly, not just listed.",
    cta: "Join the waitlist",
    navWhat: "What we do",
    navHow: "How it works",
    navJoin: "Join the list",
    whatTitle: "What Eagle Eyes Property does",
    whatMeta: "Currently onboarding · Listings soon",
    what: [
      { label: "Selection", title: "Curated apartments", text: "Every home is chosen and inspected in central Tirana neighbourhoods — no scanning through listings that don't hold up in person." },
      { label: "Management", title: "One point of contact", text: "Maintenance, paperwork, and questions go through one team, not a landlord who's hard to reach." },
      { label: "Transparency", title: "Clear terms, upfront", text: "Pricing, contracts, and deposits explained plainly before you commit — no surprises after you move in." },
    ],
    howTitle: "How it works",
    howMeta: "Three steps",
    steps: [
      { title: "Tell us what you're looking for", text: "Budget, neighbourhood, size, move-in date — the basics that actually narrow things down." },
      { title: "We match you to available homes", text: "You'll hear from us once we have apartments that fit, not a flood of options that don't." },
      { title: "Move in, with support after", text: "Signed, settled, and looked after — Eagle Eyes stays the point of contact for as long as you rent with us." },
    ],
    waitTitle: "Be first to see the apartments",
    waitText: "Eagle Eyes Property is onboarding its first homes in central Tirana. Leave your details and we'll reach out as soon as listings open.",
    neighbourhood: "Preferred neighbourhood (optional)",
    waitButton: "Join the waitlist",
    waitNote: "No spam — just a note when apartments become available.",
    footerBrand: "Eagle Eyes Property",
  },
  investment: {
    kicker: "Eagle Eyes Investment",
    h1: "Tirana residential real estate, built to be checked.",
    intro: "Eagle Eyes acquires and lets residential apartments in central Tirana through a structured Albanian holding entity — run so that every claim we make can be verified, not just taken on trust.",
    cta: "Request the information pack",
    navThesis: "How it's built",
    navTrack: "Track record",
    navContact: "Contact",
    thesisTitle: "How Eagle Eyes is built",
    thesisP1: "We acquire apartments in central Tirana neighbourhoods, let them to vetted tenants through Eagle Eyes Property, and hold them inside a dedicated company structure — separating ownership, management, and reporting so each can be reviewed on its own.",
    thesisP2: "The aim is a portfolio that grows deliberately: fewer acquisitions, each one documented well enough that an investor could reconstruct our reasoning without needing to take our word for it.",
    specs: [
      { k: "Ownership", v: "Albanian holding / SPV structure" },
      { k: "Operations", v: "Managed via Eagle Eyes Property" },
      { k: "Focus", v: "Central Tirana residential apartments" },
      { k: "Reporting", v: "Documentation available on request" },
    ],
    trackTitle: "Track record",
    trackMeta: "First acquisitions in progress",
    trackBoxTitle: "Object-by-object results — coming soon",
    trackBoxText: "As apartments are acquired, let, and (where applicable) exited, each will be listed here with the figures behind it — acquisition cost, works done, occupancy, and return.",
    trackBoxNote: "Want the current status ahead of publication? Ask below.",
    verifyTitle: "What verified investors can review",
    verify: [
      { label: "Entity", title: "Corporate structure", text: "Registration documents for the holding company and SPV, and how ownership of each apartment sits underneath them." },
      { label: "Assets", title: "Property-level detail", text: "Location, condition, acquisition terms, and rental status for each apartment held or under offer." },
      { label: "Finances", title: "Underlying figures", text: "Costs, financing terms, and rental income behind the portfolio — shared directly, not summarised away." },
      { label: "People", title: "Who's behind it", text: "Background on who runs Eagle Eyes and how the Property and Investment sides relate to one another." },
    ],
    contactTitle: "Ask to see the detail",
    contactText: "Tell us who you are and what you'd like verified. We'll follow up directly with the relevant documentation.",
    roleLabel: "I'm reaching out as…",
    roles: ["A prospective investor", "An existing investor", "Other / advisor"],
    verifyField: "What would you like to verify? (optional)",
    contactButton: "Request information",
    contactNote: "Documentation is shared directly with named individuals, not published openly.",
    footerBrand: "Eagle Eyes Investment",
  },
  it: {
    kicker: "IT Management",
    h1a: "Eagle Eyes",
    h1b: "IT Management",
    hero: "End-to-end IT consultancy tailored to your needs—from targeted, single-scope solutions and comprehensive strategies to long-term portfolio management and ongoing maintenance",
    heroCta: "Start a conversation",
    navProcess: "How we engage",
    navExpertise: "Expertise",
    navEngagements: "Engagements",
    profileTitle: "Profile",
    profile: "Eagle Eyes IT Management is a management and consultancy practice serving clients across the globe. Our consultants engage directly from first meeting to final delivery — covering endpoint, identity, device management, security and cloud hosting across Azure and Microsoft 365 — and remain responsible for the portfolio for the full contract term.",
    processTitle: "How we engage",
    process: [
      { num: "01", title: "Scope first", text: "Every engagement starts with your request, follow-up meetings and a written scope: deliverables, acceptance criteria, nothing ambiguous." },
      { num: "02", title: "Discovery", text: "A detailed investigation on agreed consultancy hours, invoiced upfront, ending in a fully costed proposal you can act on." },
      { num: "03", title: "Contracting", text: "Single services invoiced upfront. Continuing work fitted to your organisation. Portfolio management and maintenance on annual contracts with monthly invoicing. Combinations are negotiable." },
    ],
    expertiseTitle: "Expertise",
    expertise: [
      { title: "Modern workplace", items: "Windows 11 · Intune · Autopilot" },
      { title: "Microsoft 365", items: "Exchange · SharePoint · Teams · Migrations" },
      { title: "Security", items: "Defender · Hardening · Secrets · Patching" },
      { title: "Service management", items: "Jira · JSM · Confluence · Process design" },
      { title: "Identity & access", items: "Entra ID · Conditional access · MFA · SSO" },
      { title: "Azure & hosting", items: "IaaS / PaaS · Networking · Domains · SSL" },
      { title: "DevOps & CI/CD", items: "Azure DevOps · Bitbucket · Pipelines" },
      { title: "IT management", items: "Service design · Vendors · Budgets" },
    ],
    engagementsTitle: "Selected longterm engagements",
    engagements: [
      { client: "Multinational Language Software Provider", role: "IT Business Consultancy & Global DevOps Management", text: "Established the latest National subsidiary and designed the corporation's global IT architecture. This engagement involved scaling local operations from 5 to 60 professionals within 18 months, while simultaneously building and leading the cross-functional DevOps and IT management teams driving global office infrastructure." },
      { client: "Global Software Engineering Authority", role: "IT Cloud & DevOps Consultancy", text: "Structured and streamlined corporate IT infrastructure for a globally recognized leader in software development. This engagement involved building a high-performing DevOps ecosystem from the ground up and engineering a hybrid datacenter infrastructure supporting over 500 internal users." },
      { client: "Nationwide Enterprise Service Provider", role: "IT Cloud Consultancy & VoIP Architecture", text: "Delivered embedded, in-house technical consultancy for tier-one B2B clients and service providers. The core focus centered on designing and deploying highly scalable VoIP architectures and enterprise-grade cloud solutions." },
    ],
    contactTitle: "Start a conversation",
    contactText: "Tell us about your environment and what you want to achieve. We reply personally — usually within one working day.",
    companyField: "Company (optional)",
    messageField: "How can we help?",
    contactButton: "Send inquiry",
    contactBlockTitle: "Contact",
    servicesTitle: "Services & Skills",
    productsTitle: "Products & Brands",
    portfolioTitle: "Portfolio Management",
    services: ["Modern workplace", "Microsoft 365", "Security", "Service management", "Identity & access", "Azure & hosting", "DevOps & CI/CD", "IT management"],
    products: ["Microsoft 365", "Azure", "Entra ID", "Intune", "PowerShell", "Azure DevOps", "Bitbucket", "Postman", "Jira", "Jira Service Management", "Confluence", "Twilio", "Agora"],
    portfolio: ["Service design", "Vendor management", "Budget ownership", "Maintenance & support", "Annual contracting", "Monthly invoicing"],
    footerBrand: "Eagle Eyes IT Management",
  },
  digital: {
    kicker: "Eagle Eyes Digital Services",
    h1: "Products we build, run and grow.",
    intro: "Digital Services is the product studio of Eagle Eyes: we design, launch and operate our own web and mobile products in social commerce, marketing and booking.",
    navPortfolio: "The portfolio",
    navDeals: "Deals & Marketing",
    navContact: "Contact",
    appsTitle: "The portfolio",
    live: "Live",
    soon: "Coming soon",
    capsTitle: "What we build",
    caps: [
      { title: "Social commerce", text: "Turning audiences into customers with shoppable picks and deals." },
      { title: "Campaigns & deals", text: "Time-boxed promotions built for sharing and fast conversion." },
      { title: "Booking & scheduling", text: "Appointments, availability and reminders without friction." },
      { title: "Analytics & insights", text: "Every product measured from first click to repeat customer." },
    ],
    studioTitle: "An in-house product studio",
    studioText: "Digital Services designs, builds and operates Eagle Eyes' own products end to end — from first sketch to infrastructure, support and growth. No client work, no agencies: our own products, our own standard.",
    statProducts: "Products",
    statLive: "Live",
    statLaunching: "Launching",
    apps: [
      { name: "Socialdeal", tag: "Deals & marketing", status: "live", desc: "Socialdeal gives local businesses a fast way to publish time-boxed deals and campaigns, built for social sharing and direct conversion.", url: "https://www.socialdeal.al/", cta: "Visit Socialdeal", features: ["Time-boxed deal publishing", "Built for social sharing", "Direct conversion flows"] },
      { name: "BookItNow", tag: "Booking platform", status: "soon", desc: "BookItNow is our newest product: simple, fast online booking for service businesses — appointments, availability and reminders in one place.", url: "", cta: "Coming soon", features: ["Online appointment booking", "Live availability", "Automatic reminders"] },
      { name: "InContact", tag: "SIP & PBX telephony", status: "soon", desc: "InContact is our SIP & PBX system: cloud telephony with business numbers, call routing and queues — managed online, without on-premise hardware.", url: "", cta: "Coming soon", features: ["SIP trunks & hosted PBX", "Call routing & ring groups", "Numbers & voicemail online"] },
    ],
    contactTitle: "Work with us",
    contactText: "Interested in a product, a partnership or a pilot? Leave a message and we'll get back to you.",
    messageField: "Your message",
    contactButton: "Send message",
    footerBrand: "Eagle Eyes Digital Services",
  },
  inc: {
    hero1: "EAGLE",
    hero2: "INC",
    intro: "One holding, two groups — where service and development come together.",
    eyesBtn: "Eagle Eyes Group",
    eyesSub: "Real Estate · IT Management · Digital Services",
    eyesCta: "Enter Eagle Eyes Group",
    commerceBtn: "Eagle Commerce Group",
    commerceSub: "Socialdeal · BookItNow · InContact",
    commerceCta: "Enter Eagle Commerce Group",
    footerBrand: "Eagle Inc",
    footerLegal: "Eagle Inc Sh.P.K.",
    tagline: "Holding company",
  },
  commerce: {
    hero1: "EAGLE",
    hero2: "COMMERCE",
    hero3: "GROUP",
    intro: "Eagle Commerce Group designs, launches and operates its own e-commerce products — from local deals to bookings and customer contact.",
    live: "Live",
    soon: "Coming soon",
    visit: "Visit",
    explore: "Explore",
    products: [
      { name: "Socialdeal", tag: "Deals & marketing", status: "live", desc: "Local deals and marketing campaigns — published fast, shared socially, converted directly.", url: "https://www.socialdeal.al/", brand: "Eagle Commerce Socialdeal", h1: "Local deals, made to be shared.", story: "Socialdeal gives local businesses a fast, social way to publish time-boxed deals and campaigns — built for sharing, tuned for direct conversion.", points: ["Time-boxed deal publishing", "Built for social sharing", "Direct conversion flows"] },
      { name: "BookItNow", tag: "Booking platform", status: "soon", desc: "Simple, fast online booking for service businesses — appointments, availability and reminders in one place.", url: "", brand: "Eagle Commerce BookItNow", h1: "Booking, without the friction.", story: "BookItNow lets service businesses take appointments online in minutes — live availability, automatic reminders and a booking flow customers actually finish.", points: ["Online appointment booking", "Live availability", "Automatic reminders"] },
      { name: "InContact", tag: "SIP & PBX telephony", status: "soon", desc: "Cloud telephony for businesses: SIP trunks, hosted PBX and every number in one place.", url: "", brand: "Eagle Commerce InContact", h1: "Business telephony, without the hardware.", story: "InContact is a full SIP & PBX platform in the cloud: business numbers, call routing, queues and voicemail — managed online, no on-premise hardware needed.", points: ["SIP trunks & hosted PBX", "Call routing & queues", "Numbers managed online"] },
    ],
    footerBrand: "Eagle Commerce Group",
  },
};
